import React, { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "./GAListener";

// gumroad.js (index.html) turns gumroad.com links into an on-page overlay; without it the link opens a new tab.
export const GumroadButton = ({ book, label, className = "", testId, location }) => (
  <a
    href={book.url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    onClick={() =>
      trackEvent("begin_checkout", { item_name: book.title, value: book.price, currency: "USD", location })
    }
    className={`gumroad-cta inline-flex items-center justify-center gap-3 font-heading font-bold text-[13px] uppercase tracking-[0.2em] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-signal ${className}`}
  >
    {label || `Buy on Gumroad — $${book.price}`} <ArrowUpRight size={16} />
  </a>
);

// Embed node is created imperatively because gumroad-embed.js replaces it with an iframe.
export const GumroadEmbed = ({ book }) => {
  const ref = useRef(null);
  useEffect(() => {
    const host = ref.current;
    const div = document.createElement("div");
    div.className = "gumroad-product-embed";
    const a = document.createElement("a");
    a.href = book.url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.textContent = "Buy on Gumroad →";
    a.className =
      "inline-flex items-center gap-2 border border-ink px-6 py-4 font-heading font-bold text-[13px] uppercase tracking-[0.2em] hover:bg-ink hover:text-paper transition-colors";
    a.setAttribute("data-testid", "gumroad-embed-fallback-link");
    div.appendChild(a);
    host.appendChild(div);
    return () => {
      host.innerHTML = "";
    };
  }, [book.url]);
  return <div ref={ref} data-testid="gumroad-embed" className="min-h-[60px]" />;
};
